<template>
  <oil-form v-if='loading'
            title='ИНФО О ЗАЯВКЕ'
            :keys='formKeys'
            :items='order'
            :formCallback='formCallback'
            @AppendixId='Appendix'
            @ClosedAmountInTonne='calculateTonne'
            @Density='calculateDensity'
            @EmpowermentId='Empowerment'
  >

    <template v-slot:header='{id,input}'>
      <v-tooltip bottom>
        <template v-slot:activator='{ on, attrs }'>
          <v-btn type='button' icon class='mx-8'
                 @click="$router.push({
                    name:'order-from',
                    params:{orderId:id}
                 })"
                 v-bind='attrs'
                 v-on='on'
          >
            <v-icon>
              mdi-content-paste
            </v-icon>
          </v-btn>
        </template>
        <span>ДОБАВИТЬ ТТН</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator='{ on, attrs }'>
          <v-btn :disabled="!input.isEdit" class='mr-8' type='button' icon
                 @click='deleteOrder(id)'
                 v-bind='attrs'
                 v-on='on'
          >
            <v-icon color='red'>
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
        <span>{{ 'Удалить'.toUpperCase() }}</span>
      </v-tooltip>


    </template>

    <template v-slot:RemainingVolume='{input}'>
      <v-text-field
          label='Остаток в литрах'
          background-color='#709b60'
          :disabled='!input.isEdit'
          v-model="order.RemainingVolume"
          outlined
          filled
          dense
          readonly
      >
      </v-text-field>
    </template>


    <template v-slot:Buyer.Id='{rules,input}'>
      <v-autocomplete
          :items='buyers$'
          v-stream:keyup.native='searchCompany$'
          hide-no-data
          class='z-index'
          :disabled='!input.isEdit'
          clearable
          :rules='[...rules]'
          dense
          outlined
          @change='Buyer'
          hide-selected
          :value='order.Buyer.CompanyName'
          item-text='CompanyName'
          label='Выбрать покупателя'
          return-object
      ></v-autocomplete>
    </template>
    <template v-slot:Contract.Id='{rules,input}'>
      <v-autocomplete
          :items='contracts$'
          v-stream:keyup.native='searchContract$'
          hide-no-data
          class='z-index'
          :disabled='!input.isEdit'
          :rules='[...rules]'
          clearable
          @change='Contract'
          dense
          outlined
          :value='order.Contract.Number'
          hide-selected
          item-text='Number'
          label='Выбрать договор'
          return-object
      ></v-autocomplete>
    </template>


    <template v-slot:Appendix.Id='{input}'>
      <v-select
          :disabled='!input.isEdit'
          label='Выбрать приложение'
          v-model='order.Appendix.Id'
          item-value='Id'
          item-text='Number'
          @change="Appendix"
          :items='appendixes'
          outlined
          dense
          return-object
      >
      </v-select>

    </template>
    <template v-slot:Empowerment.Id='{input}'>
      <v-select
          :disabled='!input.isEdit'
          label='Выбрать доверенность'
          v-model='order.Empowerment.Id'
          item-value='Id'
          item-text='Number'
          :items='epowerments'
          @change="Empowerment"
          outlined
          dense
          return-object
      >
      </v-select>

    </template>


  </oil-form>
</template>

<script>
//services
import {companiesService} from '@/services/CompaniesService'
import {contractsService} from '@/services/ContractsService'
import {orderService} from '@/services/OrderService'
import {coreApi} from '@/services/core'
import update from './globalFunctionsInThisDirectory.js'

export default {
  mixins: [update],
  props: {
    id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      inputIsEdit: false,
      readonlyBuyer: false,
      readonlyContract: false,
      readonlyProgram: false,
      readonlyProcuration: false,
      readonlyOrder: false
    }
  },
  async created() {
    this.resetAll()
    const companies = await companiesService.getAll()
    this.buyers = companies.data || []
    const order = await orderService.getById(this.id)
    this.order = order.data

    const buyer = this.order?.Buyer
    await this.Buyer(buyer)
    const id = this.order?.Contract?.Id
    if (id) {
      const contract = await contractsService.getById(id)
      await this.Contract(contract.data)
      const apId = order.data?.Appendix?.Id
      const appendix = this.appendixes?.find(({Id}) => Id === apId)
      this.Appendix(appendix)
    }

    if (this.order?.Buyer) {
      this.readonlyBuyer = true
    }
    if (this.order?.Contract) {
      this.readonlyContract = true
    }
    if (this.order?.Appendix) {
      this.readonlyProgram = true
    }
    if (this.order?.Contract) {
      this.readonlyProcuration = true
    }

    this.order.Buyer ??= {}
    this.order.Contract ??= {}
    this.order.Appendix ??= {}
    this.order.Empowerment ??= {}

    this.loading = true
  },
  computed:{
    message(){
      return this.id ? "заявка удачно изменена" : "заявка удачно создана"
    }
  },
  methods: {
    async formCallback(data, input, form,func) {
      input.isEdit = false
      func(this.message)
      const response = await orderService.update(data)
      const order = response.data
      if (!order) {
        input.isEdit = true
        return
      }

      this.order = {...order}

      this.order.Buyer ??= {}
      this.order.Contract ??= {}
      this.order.Appendix ??= {}
      this.order.Empowerment ??= {}
    },

    async deleteOrder(id) {
      const response = await coreApi.delete(`order?id=${id}`)
      const isDelete = response.data
      if (isDelete) {

        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Заявка под номером ${this.order.Number} удачно удален`
        })

        window.location = '/orders'

        await this.$router.push({
          name: 'orders',
          replace: true
        })

      }
    },


    calculateTonne(liter) {
      if (isNaN(parseFloat(liter))) return

      const result = liter * this.order.Density / 1000
      let res = parseFloat(result).toFixed(4)
      if (isNaN(res)) {
        res = 0
      }
      this.order.GrossPerTonne = res
    },


    //objects
    async Buyer(buyer) {
      if (!buyer) return
      this.resetAll(false)
      this.order.Buyer = {...buyer}
    },
    Contract(contract) {
      if (!contract) return
      this.order.Contract = contract
      this.appendixes = contract.Appendixes || []
    },
    Appendix(appendix) {
      if (!appendix) return
      this.order.Appendix = {...appendix}
      this.order.AppendixNumber = appendix.Number
      this.order.Item = {...appendix.Item}
    },
    Empowerment(empowerment) {
      if (!empowerment) return
      this.order.Empowerment = empowerment
    }

  },
  watch: {}
}
</script>
